// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1350":"76625057","7296":"120648ca","7407":"5d67a4b6","8599":"5d67a4b6"}[chunkId] + ".chunk.css";
};